<template>
	<div id="app">
		<!--<transition name="bounce">-->
		<router-view></router-view>
		<!--</transition>-->
	</div>
</template>

<script>

    export default {
        name: 'app',
        components: {
        }
    }
</script>

<style>
	.bounce-enter-active {
		animation: bounce-in .5s;
	}

	.bounce-leave-active {
		animation: bounce-out .2s;
	}

	@keyframes bounce-in {
		0% {
			transform: scale(0);
		}
		50% {
			transform: scale(1.05);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes bounce-out {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.95);
		}
		100% {
			transform: scale(0);
		}
	}



	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s
	}
	.fade-enter, .fade-leave-active {
		opacity: 0
	}


	body {
		/*background-color: #324057;*/
		margin: 0px;
		padding: 0px;
		 background: url(./assets/bg.jpg) no-repeat !important; 
		background-size: cover !important;
		height:100%;
		width:100%;
		overflow: hidden;
		background: #467A9E;
		font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
		/*font-weight: 400;*/
		font-size:14px;
		-webkit-font-smoothing: antialiased;
	}

	#app {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
	}

	.el-submenu [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}

	.el-menu-item [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}

	.toolbar .el-form-item {
		margin-bottom: 10px;
	}

	.toolbar {
		background: #fff;
		padding: 10px 10px 0px 10px;
	}

  .table_label { background: #e8f5fe; text-align: right; }
  .el-table th.gutter{
    display: table-cell!important;
  }
  /*.table font-size*/

  .el-table--mini, .el-table--small, .el-table__expand-icon {
    font-size: 14px;
  }

  .el-button--mini:hover{
    color: #4069ff;
    font-weight:600;
  }
  .el-checkbox{
	display: block;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue